import { useCallback, useState } from 'react';

export default function useModal(initial = { open: false }) {
    const [state, setState] = useState({ open: Boolean(initial.open), payload: initial.payload || null });

    const openWith = useCallback((payload) => setState({ open: true, payload }), []);
    const close = useCallback(() => setState({ open: false, payload: null }), []);

    return { state, openWith, close, setState };
}


